module.exports = {
  MODERATOR: 1,
  MEMBER: 2,
  REQUESTED: 3,
  INVITED: 4,
  MODERATORINVITED: 5,
}